/**
 * Format a phone number for display.
 * Handles common North American formats:
 *   "5551234567"     → "(555) 123-4567"
 *   "15551234567"    → "+1 (555) 123-4567"
 *   "+15551234567"   → "+1 (555) 123-4567"
 *   "555-123-4567"   → "(555) 123-4567"
 *   Already formatted → returned as-is
 */
export function formatPhoneNumber(phone: string | undefined | null): string {
  if (!phone) return "";

  // Strip everything except digits and leading +
  const hasPlus = phone.startsWith("+");
  const digits = phone.replace(/\D/g, "");

  // 10 digits  -  standard North American
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  // 11 digits starting with 1  -  North American with country code
  if (digits.length === 11 && digits.startsWith("1")) {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }

  // International or already formatted  -  return with + if it had one
  if (hasPlus && !phone.startsWith("+")) {
    return `+${phone}`;
  }

  // If it already looks formatted (has parens, dashes, or spaces), return as-is
  if (/[()-\s]/.test(phone) && digits.length >= 7) {
    return phone;
  }

  // Fallback: return original
  return phone;
}
